let tokenManagerInstance: TokenManager | null = null;
let refreshPromise: Promise<string | null> | null = null;

export class TokenManager {
    private constructor() {
        console.log('TokenManager instance created');
    }

    static getInstance(): TokenManager {
        if (!tokenManagerInstance) {
            tokenManagerInstance = new TokenManager();
        }
        return tokenManagerInstance;
    }

    getToken(): string | null {
        try {
            const tokens = JSON.parse(localStorage.getItem('tokens') || '{}');
            return tokens.accessToken || null;
        } catch {
            return null;
        }
    }

    setToken(token: string): void {
        localStorage.setItem('tokens', JSON.stringify({ accessToken: token }));
    }

    async refreshAccessToken(): Promise<string | null> {
        if (refreshPromise) {
            console.log('DEDUPLICATION: Refresh already in progress, reusing promise');
            return refreshPromise;
        }

        console.log('NEW REFRESH: Starting token refresh request');

        refreshPromise = (async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/saml/refresh`,
                    {
                        method: 'POST',
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' }
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    if (data?.accessToken) {
                        this.setToken(data.accessToken);
                        return data.accessToken;
                    }
                }

                console.log('Token refresh failed');
                return null;
            } catch (error) {
                console.error('Token refresh failed:', error);
                return null;
            } finally {
                refreshPromise = null;
                console.log('Refresh promise cleared');
            }
        })();

        return refreshPromise;
    }

    clearToken(): void {
        localStorage.removeItem('tokens');
    }
}